import type { DefinitionItem } from '@/common/graphql';

export const getGeneralDefinition = (
  definitions: Array<Pick<DefinitionItem, 'languageCode' | 'content'>> | undefined,
  preferredLanguage: string = 'en',
) => {
  if (!definitions) return;
  return (
    definitions.find(it => it.languageCode === preferredLanguage)?.content ||
    definitions.find(it => it.languageCode === 'en')?.content
  );
};
